import { GridRowId } from '@material-ui/data-grid';
import { useEffect } from 'react';
import { useState } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { TableColumn, TableWithCollapse } from '../../../../lib/DataTable';
import { useTableWithCollapse } from '../../../../lib/DataTable/customHooks';
import { fetchInvestorDetails, onSaveImageData } from '../../../../redux-store/actions/nct';
import { RootStateType } from '../../../../redux-store/reducers';
import { LIST_PROTFOLIO_PAYLOAD } from '../../../../redux-store/types/portfolio';
import { getInvestorFunds, notLockedFolio, portfoliosByMinorStatus } from '../../portfolios/utils';
import { ConsolidateTableRowType } from '../ConsolidationFolios/types';
import en from '../../../../lang/en-us';
import { SubmitButton } from '../../../../lib/Button';
import NoFoliosFound from '../NoFoliosFound';
import { DOCUMNENTS } from '../../../quick-links/TransmissionRequest/transmission-download-list';
import { UploadFile } from '../../../../lib/UploadFile.tsx';
import { ActionHeader, FaqLink } from '..';
import { GENERAL } from '../../../../utils/constants';
import { ImageSaveType } from '../../../../redux-store/types/nct';

const { dashboard } = en;

export type HistoryStateProps = {
    deceasedPersonPAN: string;
    targetFunds?: TransmissonRowData[];
    formsTobeTaken?: DOCUMNENTS[];
};
interface TransmissionProps extends RouteComponentProps<any, any, HistoryStateProps> {
    pan: string;
    mobile: string;
    reqId: string;
    pekrn: string;
    fetchInvestorDetails: (body: LIST_PROTFOLIO_PAYLOAD) => Promise<any>;
    onSaveImageData: (body: any) => {};
}

export type TransmissonRowData = {
    id: GridRowId;
    amcName: string;
    holderName: string;
    holderPosition: number;
    amc: string;
};

const Columns: TableColumn[] = [
    {
        headerName: 'Folio NO',
        field: 'id',
    },
    {
        headerName: 'Fund House',
        field: 'amcName',
        filterHeader: 'Fund House',
    },
    {
        headerName: 'Deceased Holder Name',
        field: 'holderName',
    },
    {
        headerName: 'Holding Position',
        field: 'holderPosition',
        valueGetter: ({ value }) => (value === 2 ? `${value}nd Holder` : `${value}rd Holder`),
    },
];

function TransmissionList(props: TransmissionProps) {
    const [panDetails, setPanDetails] = useState<TransmissonRowData[]>([]);
    const { deceasedPersonPAN = '' }: any = props.location.state || {};
    const [loading, setLoading] = useState<boolean>(false);
    const [image, setImage] = useState({
        name: 'deathCertificate',
        format: '',
        content: '',
    });
    const { tableRows, tableColumns, setSelectedRows, selectedRows } = useTableWithCollapse<
        TransmissonRowData[]
    >({
        rows: panDetails,
        columns: Columns,
        loading,
    });

    useEffect(() => {
        if (!deceasedPersonPAN) {
            props.history.push('/');
        }
    }, []);

    useEffect(() => {
        async function callApi() {
            setLoading(true);
            const reqBody: LIST_PROTFOLIO_PAYLOAD = {
                pan: props.pan,
                pekrn: props.pekrn,
                reqId: props.reqId,
                mobile: props.mobile,
            };
            const { body: investorDetails = {} } = await props.fetchInvestorDetails(reqBody);
            const { success: investorData = [] } = investorDetails;
            const investorFunds = getInvestorFunds(
                investorData,
                [notLockedFolio],
                [portfoliosByMinorStatus],
            );
            const rowData = investorFunds.reduce(
                (prev: TransmissonRowData[], curr: ConsolidateTableRowType) => {
                    const {
                        secondHolderPan,
                        thirdHolderPan,
                        secondHolderPekrn,
                        thirdHolderPekrn,
                        secondHolder,
                        thirdHolder,
                        id,
                        amcName,
                        amc,
                    } = curr;
                    const staticProps = {
                        id,
                        amcName,
                        amc,
                    };
                    if (deceasedPersonPAN === (props.pan ? secondHolderPan : secondHolderPekrn)) {
                        return [
                            ...prev,
                            {
                                ...staticProps,
                                holderName: secondHolder,
                                holderPosition: 2,
                            },
                        ];
                    }
                    if (deceasedPersonPAN === (props.pan ? thirdHolderPan : thirdHolderPekrn)) {
                        return [
                            ...prev,
                            {
                                ...staticProps,
                                holderName: thirdHolder,
                                holderPosition: 3,
                            },
                        ];
                    }
                    return prev;
                },
                [],
            );
            setPanDetails(rowData);
            setLoading(false);
            setSelectedRows(rowData);
        }
        callApi();
    }, []);

    // const _isRowSeletable = ({ row }: { row: TransmissonRowData }) => {
    //     if (selectedRows.length) {
    //         const [fund] = selectedRows;
    //         if (fund.amc !== row.amc) {
    //             return false;
    //         }
    //     }
    //     return true;
    // };

    // const _toolTipGetText = ({ row }: { row: TransmissonRowData }) => {
    //     if (selectedRows.length) {
    //         const [fund] = selectedRows;
    //         if (fund.amc !== row.amc) {
    //             return `AMC's selection should be same`;
    //         }
    //     }
    //     return '';
    // };

    useEffect(() => {
        return () => {
            const imageInfo: ImageSaveType = {
                data: [image],
                type: 'DEATH_CERTIFICATE',
            };
            props.onSaveImageData(imageInfo);
        };
    }, [image]);

    return (
        <div className="curved-bg">
            <ActionHeader header={dashboard.TransmissionRequest.TransmissionRequestHeading} />
            <div className="curved-bg-content curved-bg-table-outer">
                <div className="curved-bg-content-table">
                    {!tableRows.length && !loading ? (
                        <NoFoliosFound />
                    ) : (
                        <>
                            <h5>{dashboard.TransmissionRequest.followingFolios}</h5>
                            <TableWithCollapse
                                selectedRows={selectedRows}
                                setSelectedRows={setSelectedRows}
                                rows={tableRows}
                                columns={tableColumns}
                                isRowSelectable={() => false}
                                // toolTipTextGetter={_toolTipGetText}
                                toolTipEnabled
                                checkBoxEnabled
                                isCheckBoxSelectable={false}
                            />
                            <div className="transmission-dc-upload">
                                <h6>{dashboard.TransmissionRequest.uploadDC}</h6>
                                <UploadFile
                                    onImageSelected={(value: any, format: any) => {
                                        setImage({
                                            ...image,
                                            format: format,
                                            content: value,
                                        });
                                        props.onSaveImageData(image);
                                    }}
                                    id={'deathCertificate'}
                                />
                            </div>
                        </>
                    )}
                </div>
                <FaqLink section={GENERAL} history={props.history} />
                <div className="curved-bg-content-inner-bottom">
                    {!!tableRows.length && (
                        <SubmitButton
                            disabled={!image.content}
                            label={dashboard.BankMandate.buttonText}
                            className="customBtn"
                            onClick={() =>
                                props.history.replace('/portal/nct/transmission-download', {
                                    deceasedPersonPAN,
                                    targetFunds: selectedRows,
                                })
                            }
                        />
                    )}
                </div>
            </div>
        </div>
    );
}

export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), {
    fetchInvestorDetails,
    onSaveImageData,
})(TransmissionList);
